__webpack_require__.p = "//etoro.boursier.com/5g/";